/**
 * /tracking/iframe-gateway — operator route for feature #163.
 *
 * Declares a TanStack Router route and renders `IframeGatewayPage`. Root
 * wire-up picks this up from `router.tsx` after the prod-main merge.
 *
 * `?advertiserId=` deep-links the page scoped to one advertiser, so ops
 * people can jump here from an advertiser detail view.
 */

import { createRoute, Link } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { IframeGatewayPage } from "@/features/iframe-gateway/IframeGatewayPage";

interface TrackingIframeGatewaySearch {
	advertiserId?: string;
}

export const trackingIframeGatewayRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/tracking/iframe-gateway",
	validateSearch: (
		raw: Record<string, unknown>,
	): TrackingIframeGatewaySearch => {
		const v = raw.advertiserId;
		if (typeof v === "string" && v.trim().length > 0) {
			return { advertiserId: v.trim() };
		}
		return {};
	},
	component: TrackingIframeGatewayRoute,
});

export default trackingIframeGatewayRoute;

export function TrackingIframeGatewayRoute() {
	const { advertiserId } = trackingIframeGatewayRoute.useSearch();

	return (
		<div className="flex flex-col">
			<nav
				aria-label="Breadcrumb"
				className="mx-auto w-full max-w-6xl px-6 pt-10 text-sm text-zinc-500 sm:pt-16"
			>
				<ol className="flex flex-wrap items-center gap-1">
					<li>
						<Link
							to="/"
							className="rounded-[6px] px-1 py-0.5 hover:bg-zinc-100 hover:text-zinc-900"
						>
							Dashboard
						</Link>
					</li>
					<li aria-hidden="true" className="text-zinc-300">
						/
					</li>
					<li>
						<span className="rounded-[6px] px-1 py-0.5">Tracking</span>
					</li>
					<li aria-hidden="true" className="text-zinc-300">
						/
					</li>
					<li className="text-zinc-900">Iframe gateway</li>
				</ol>
			</nav>

			<IframeGatewayPage initialAdvertiserId={advertiserId} />
		</div>
	);
}

// Named export for the root wire-up cycle.
export { TrackingIframeGatewayRoute as TrackingIframeGatewayPage };
